<template lang="pug">
div
  .form-group(v-if="hasMultiple")
    Label(:text="label")
    SelectInput(
      v-model="subsiteId"
      :options="options"
      :blank-option-name="'None'"
    :disabled="!publicationId"
  )
</template>

<script>

  import { mapStores, mapState } from 'pinia'
  import { useSubsitesStore } from '@/stores/subsites'
  import { isEmpty } from 'lodash'

  import Label from './label.vue'
  import SelectInput from './select_input.vue'

  export default {
    components: {
      Label,
      SelectInput
    },

    props: {
      publicationId: {
        type: Number,
        required: false
      },

      // NOTE: be careful that the value matches the option value. Number strings are a common issue.
      value: {
        type: Number,
        default() { return null }
      },

      label: {
        type: String,
        default() { return 'Subsite' }
      }
    },

    data() {
      return {
        subsiteId: null,
      }
    },

    computed: {
      ...mapStores(useSubsitesStore),
      ...mapState(useSubsitesStore, ['hasMultiple']),
      options() {
        if (!this.publicationId) return {}

        return this.subsitesStore.forPublicationAsObject({ publicationId: this.publicationId })
      }
    },

    watch: {
      value() {
        this.subsiteId = this.value
      },

      subsiteId() {
        // For component v-model support
        this.$emit('input', this.subsiteId);
      }
    },

    async mounted() {
      await this.subsitesStore.fetchOnce()

      this.subsiteId = this.value
    }
  }
</script>
